<!-- </div>&NonBreakingSpace;&NonBreakingSpace; -->
<div class="header d-flex justify-content-between">
  <h4 for="label">{{variables.userManagement}}</h4>
  <div style="display: flex;">
    <app-button typeBtn="primary" style="margin-left: 10px;" message="{{variables.addUser}}" [textColor]="colorWhite"
      [color]="'var(--primary-color)'" (click)="addUser()"></app-button>
  </div>
</div>

<div class="filters-row">
  <mat-form-field class='user-search-field' appearance="outline">
    <input matInput placeholder="{{variables.search}}..." search (keyup)="onCheckboxChange($event)" />
  </mat-form-field>

  @if (showTenantFilter) {
  <mat-form-field class="user-tenant-filter-field" appearance="outline">
    <mat-label>{{ variables.tenantSelectLabel }}</mat-label>
    <mat-select [value]="selectedTenantId" (selectionChange)="onTenantFilterChange($event.value)">
      <mat-option value="">{{ variables.tenantFilterAll }}</mat-option>
      @for (t of tenants; track t.id) {
      <mat-option [value]="t.id">{{ t.name }} ({{ t.id }})</mat-option>
      }
    </mat-select>
  </mat-form-field>
  }
</div>

@if (isLoading && !errorDetected) {
<app-loader class="centerLoader pt-5"></app-loader>
}

@if (errorDetected) {
<app-error-message [errorMsg]="errorText"></app-error-message>
}

<!-- manage user's table -->
@if (!isLoading && !errorDetected) {
<div>
  <div class="estimates mb-5">
    <div class="mat-elevation-z0">
      <table mat-table [dataSource]="dataSourceUsers">
        <!-- Name  forçar reset de pass, desativar utilizador e gerar nova pass ao utilizador-->
        <ng-container matColumnDef="name">
          <th mat-header-cell style="flex-basis: 25%;" *matHeaderCellDef>
            <strong>
              {{variables.name}}
            </strong>
          </th>
          <td mat-cell style="flex-basis: 25%;" *matCellDef="let element">
            <div style="display: flex; align-items: center;">
              @if (id === element.id) {
              <strong style="margin-right: 8px;">
                ({{variables.ME}})
              </strong>
              }
              <span>{{element.name}} {{element.lastName}}</span>
            </div>
          </td>
        </ng-container>
        <!-- email -->
        <ng-container matColumnDef="email">
          <th mat-header-cell style="flex-basis: 30%;" *matHeaderCellDef>
            <strong>
              Email
            </strong>
          </th>
          <td mat-cell style="flex-basis: 30%;" *matCellDef="let element">
            {{element.email}}
          </td>
        </ng-container>
        <!-- ROLE -->
        <ng-container matColumnDef="role">
          <th mat-header-cell style="flex-basis: 15%;" *matHeaderCellDef>
            <strong>
              {{variables.role}}
            </strong>
          </th>
          <td mat-cell style="flex-basis: 15%;" *matCellDef="let element">
            @if (element.role === 'SUPER-ADMIN') {
            {{variables.superAdmin}}
            }
            @if (element.role === 'ADMIN') {
            {{variables.admin}}
            }
            @if (element.role === 'ARCHITECT') {
            {{variables.architect}}
            }
            @if (element.role === 'USER') {
            {{variables.normalUser}}
            }
            @if (element.role === 'ESTIMATION-OFFICE') {
            {{variables.estimationOffice}}
            }
            @if (element.role === 3) {
            {{variables.architect}}
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="tenant">
          <th mat-header-cell style="flex-basis: 18%;" *matHeaderCellDef>
            <strong>{{ variables.tenantColumn }}</strong>
          </th>
          <td mat-cell style="flex-basis: 18%;" *matCellDef="let element">
            {{ element.tenantName || element.tenantId || '—' }}
          </td>
        </ng-container>
        <!-- Active -->
        <ng-container matColumnDef="active">
          <th mat-header-cell style="flex-basis: 10%;" *matHeaderCellDef>
            <strong>
              {{variables.active}}
            </strong>
          </th>
          <td mat-cell style="flex-basis: 10%;" *matCellDef="let element">
            @if (element.active) {
            {{variables.active}}
            }
            @if (!element.active) {
            {{variables.inactive}}
            }
          </td>
        </ng-container>
        <!-- ACTIONS -->
        <ng-container matColumnDef="actions">
          <th mat-header-cell style="flex-basis: 20%;" class="horizontal-center" *matHeaderCellDef>
            <strong>
              {{variables.actions}}
            </strong>
          </th>
          <td mat-cell style="flex-basis: 20%;" class="horizontal-center" *matCellDef="let element">
            <div class="action_buttons">
              <span (click)="editUser(element)" class="action_buttons-item">
                <img src="../../../../assets/svg/EditWhite.svg" alt="Edit Icon" title="Edit User Atributes"
                  width="20px">
              </span>
              <span (click)="forcePassChange(element)" class="action_buttons-item spanIntervals">
                <img src="../../../../assets/svg/ResetPassWhite.svg" alt="Reset Password" title="Reset User Password"
                  width="25px">
              </span>
              <span (click)="rewindPassChange(element)" class="action_buttons-item spanIntervals">
                <img src="../../../../assets/svg/ForcePassResetWhite.svg" alt="Force Reset Password"
                  title="Force Reset User Password" width="20px">
              </span>
              <span (click)="changeUserActiveStatus(element)" class="action_buttons-item spanIntervals">
                <img src="../../../../assets/svg/ActivateUserWhite.svg" alt="Activate User" title="Change Active Status"
                  width="20px">
              </span>
            </div>
          </td>
        </ng-container>
        <mat-header-row *matHeaderRowDef="displayedColumns1"></mat-header-row>
        <mat-row *matRowDef="let row; columns: displayedColumns1;"></mat-row>
      </table>
    </div>
    <mat-paginator #paginator class="paginator-min-width" [length]="paginatorTotalElements"
      [pageSize]="paginatorPageSize" [hidePageSize]="true" [pageIndex]="paginatorCurrentIndex" aria-label="Select page"
      (page)="onPageChange($event)"></mat-paginator>
    <div>
      <!-- <div style="float: right;">
                <app-button style="margin-right: 10px;" (click)="addUser()" [textColor]="colorWhite" color="#fc6d42" width="250px" message="{{variables.addUser}}"></app-button>
                <app-button (click)="saveUser()" [textColor]="colorWhite" color="#fc6d42" width="250px" message="{{variables.save1}}"></app-button>
              </div> -->
    </div>
  </div>
</div>
}